import { render, staticRenderFns } from "./UserInvitationConfirm.vue?vue&type=template&id=3f30548a&scoped=true"
import script from "./UserInvitationConfirm.vue?vue&type=script&lang=js"
export * from "./UserInvitationConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f30548a",
  null
  
)

export default component.exports